import { RouteConfig } from "vue-router";
import Home from "hfox/views/home.vue";

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "index",
    component: Home
  },
  {
    path: "/check_balance",
    name: "check_balance",
    component: () => import("hfox/views/check_balance.vue")
  },
  {
    path: "/plan/:id",
    name: "plan-id",
    component: () => import("hfox/views/plan/_id/index.vue")
  },
  {
    path: "/plan/:id/edit",
    name: "plan-id-edit",
    component: () => import("hfox/views/plan/_id/edit.vue")
  },
  {
    path: "/create",
    name: "plan-create",
    component: () => import("hfox/views/plan/create.vue")
  },
  {
    path: "/plan/:id/schedules",
    name: "plan-id-schedules",
    component: () => import("hfox/views/plan/_id/schedules.vue")
  },
  {
    path: "/toushi/callback",
    name: "toushi-callback",
    component: () => import("hfox/views/toushi/callback.vue")
  }
];

export default routes;
